import { useEffect, useState } from 'react';

const navLinks = [
  { label: '首页', href: '#top' },
  { label: '分类精选', href: '#categories' },
  { label: '爆笑连载', href: '#comics' },
  { label: '今日热门', href: '#hot' },
  { label: '小编推荐', href: '#picks' },
  { label: '常见问题', href: '#faq' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState('');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const submitSearch = () => {
    const k = keyword.trim();
    if (!k) return;
    const list = document.querySelector<HTMLElement>('#comics');
    if (list) {
      list.scrollIntoView({ behavior: 'smooth' });
      list.dispatchEvent(new CustomEvent('comic:search', { detail: k }));
    }
    setOpen(false);
  };

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      <nav
        className={`transition-all duration-300 ${
          scrolled
            ? 'bg-background-50/90 shadow-soft backdrop-blur-md'
            : 'bg-transparent'
        }`}
        aria-label="主导航"
      >
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:h-[76px] md:px-6">
          {/* logo */}
          <a href="#top" className="flex items-center gap-2" aria-label="哈哈漫画网 首页">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-xl text-background-50">
              <i className="ri-emotion-laugh-line" aria-hidden="true"></i>
            </span>
            <span className="font-heading text-xl md:text-2xl text-foreground-950">
              哈哈漫画网
            </span>
          </a>

          {/* desktop nav */}
          <div className="hidden items-center gap-1 lg:flex">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="whitespace-nowrap rounded-full px-4 py-2 text-sm text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
              >
                {l.label}
              </a>
            ))}
          </div>

          {/* right actions */}
          <div className="flex items-center gap-2 md:gap-3">
            <div className="hidden items-center gap-2 rounded-full border border-background-300 bg-background-50/80 px-3 py-1.5 md:flex">
              <i className="ri-search-line text-sm text-foreground-500" aria-hidden="true"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && submitSearch()}
                placeholder="搜一搜好笑的漫画"
                className="w-36 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
                aria-label="搜索漫画"
              />
            </div>
            <a
              href="#comics"
              className="hidden whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
            >
              立即追更
            </a>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-lg border border-background-300 text-foreground-800 lg:hidden"
              aria-label="展开菜单"
              aria-expanded={open}
            >
              <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true"></i>
            </button>
          </div>
        </div>

        {/* mobile menu */}
        {open && (
          <div className="border-t border-background-200 bg-background-50/95 backdrop-blur-md lg:hidden">
            <div className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-4 md:px-6">
              <div className="mb-2 flex items-center gap-2 rounded-full border border-background-300 px-3 py-2">
                <i className="ri-search-line text-sm text-foreground-500" aria-hidden="true"></i>
                <input
                  type="text"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && submitSearch()}
                  placeholder="搜一搜好笑的漫画"
                  className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
                  aria-label="搜索漫画"
                />
              </div>
              {navLinks.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="rounded-lg px-3 py-2.5 text-sm text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="#comics"
                onClick={() => setOpen(false)}
                className="mt-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-center text-sm font-medium text-background-50"
              >
                立即追更
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}